import { render, staticRenderFns } from "./main-with-detail-layout.vue?vue&type=template&id=785088d5&scoped=true&"
import script from "./main-with-detail-layout.vue?vue&type=script&lang=js&"
export * from "./main-with-detail-layout.vue?vue&type=script&lang=js&"
import style0 from "./main-with-detail-layout.vue?vue&type=style&index=0&id=785088d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785088d5",
  null
  
)

export default component.exports